/**
 * LocalStorage utilities for clearing legacy data
 */

export function clearLegacyData() {
  const keysToRemove = [
    'org_slug',
    'access_token', 
    'refresh_token',
    'token_expires_at',
    'authToken',
    'currentOrganization',
    'user',
    'organization',
    'mst-persist', // Clear all MST persisted data
    'UserStore',
    'AuthStore',
    'OrganizationStore',
    'ChatStore'
  ];
  
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
  
  // Clear all keys that start with known prefixes
  const allKeys = Object.keys(localStorage);
  allKeys.forEach(key => {
    if (key.startsWith('mst-') || key.startsWith('Store') || key.includes('Organization')) {
      localStorage.removeItem(key);
    }
  });
  
  console.log('🧹 Cleared ALL legacy localStorage data and MST persistence');
}

export function initializeAppStorage() {
  // Clear any legacy hardcoded data on app start
  clearLegacyData();
}
